import styled from 'styled-components'
import { normalizeWidth } from '../../../utils/normalize';

export const MessageWrapper = styled.div<{ sent: boolean, selected: boolean, selectingMessages: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: ${(props) => props.sent ? 'flex-end' : 'flex-start'};
  background-color: ${(props) => props.selected ? 'rgba(110, 48, 232, 0.08)' : 'transparent'};
`;

export const MessageComponentsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const TextWrapper = styled.div<{ sent: boolean }>`
  display: flex;
  flex-direction: column;
  max-width: ${normalizeWidth(187)};
  cursor: pointer;
  padding: 16px;
  border-radius: 12px;
  align-self: ${(props) => props.sent ? 'flex-end' : 'flex-start'};
  background-color: ${(props) => props.sent ? 'transparent' : '#E6E6E6'};
  border: ${(props) => props.sent ? '1px solid #E6E6E6' : '1px solid #E6E6E6'};
  word-wrap: break-word;
`;

export const Text = styled.p`
  font-size: 14px;
  line-height: 140%;
  color: #1B1B1B;
`;

export const SelectIconWrapper = styled.div`
  width: 22px;
  height: 22px;
  align-items: center;
  justify-content: center;
  display: flex;
  cursor: pointer;
  margin-left: 11.5px;
  margin-right: 11.5px;
`;

export const LikedIconWrapper = styled.div<{ sent: boolean }>`
  margin-top: -24px;
  transform: translateY(100%);
  align-self: ${(props) => props.sent ? 'flex-end' : 'flex-start'};
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const OptionIcon = styled.div`
  width: 24px;
  height: 24px;
  cursor: pointer;
`;